import { render, staticRenderFns } from "./Wavicle.vue?vue&type=template&id=59031001&"
import script from "./Wavicle.vue?vue&type=script&lang=js&"
export * from "./Wavicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports